export default __webpack_public_path__ + "static/media/Boots of Conflagrant Flame.b10b41de.jpg";